import { canUseLocalStorage } from '@ps/web-core-utils';

import { ACTIVE_GAMES_LOCAL_STORAGE_KEY } from './activeGames';

export const getStoredActiveGameIds = (): number[] => {
  if (!canUseLocalStorage) return [];
  try {
    const item = localStorage.getItem(ACTIVE_GAMES_LOCAL_STORAGE_KEY);
    return item ? (JSON.parse(item) as number[]) : [];
  } catch {
    return [];
  }
};

export const setStoredActiveGameIds = (ids: number[]): void => {
  if (!canUseLocalStorage) return;
  localStorage.setItem(ACTIVE_GAMES_LOCAL_STORAGE_KEY, JSON.stringify(ids));
};

export const mergeStoredActiveGameIds = (newIds: number[]): void => {
  const existing = getStoredActiveGameIds();
  const merged = Array.from(new Set([...existing, ...newIds]));
  setStoredActiveGameIds(merged);
};

export const syncStoredActiveGameIds = (validIds: number[]): void => {
  const stored = getStoredActiveGameIds();
  const filtered = stored.filter((id) => validIds.includes(id));
  setStoredActiveGameIds(filtered);
};

export const removeStoredActiveGameIds = (idsToRemove: (number | string)[]): void => {
  const toRemoveSet = new Set(idsToRemove.map((id) => Number(id)));
  const stored = getStoredActiveGameIds();
  const filtered = stored.filter((id) => !toRemoveSet.has(id));
  setStoredActiveGameIds(filtered);
};
